/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Bannertitle1Inputs */

const en_auth_bannertitle1 = /** @type {(inputs: Auth_Bannertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investors. Operators. Innovators.`)
};

/**
* | output |
* | --- |
* | "Investors. Operators. Innovators." |
*
* @param {Auth_Bannertitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_bannertitle1 = /** @type {((inputs?: Auth_Bannertitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Bannertitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_bannertitle1(inputs)
});
export { auth_bannertitle1 as "auth_bannerTitle" }